import { atom, atomWithDefault } from '~shared/lib/atom-state';

import { getParentVoucherNotifications, getParentVoucherNotificationsUnreadCount } from '../api';
import type { ApiParentVoucherNotificationsResponse } from '../api';

export const parentVoucherNotificationsAtom =
  atomWithDefault<ApiParentVoucherNotificationsResponse | null>(() => null);

export const parentVoucherNotificationsLoadingAtom = atomWithDefault<boolean>(() => false);

export interface ParentVoucherNotificationsQuery {
  page?: number;
  limit?: number;
}

export const setParentVoucherNotificationsAtom = atom<
  ApiParentVoucherNotificationsResponse | null,
  ParentVoucherNotificationsQuery,
  Promise<void>
>(
  (get) => get(parentVoucherNotificationsAtom),
  async (get, set, params) => {
    const { page = 1, limit = 20 } = params ?? {};
    set(parentVoucherNotificationsLoadingAtom, true);

    try {
      const data = await getParentVoucherNotifications(page, limit);

      if (page === 1 || !data) {
        set(parentVoucherNotificationsAtom, data);
      } else {
        const prev = get(parentVoucherNotificationsAtom);

        set(parentVoucherNotificationsAtom, {
          data: [...(prev?.data ?? []), ...data.data],
          pagination: data.pagination,
        });
      }
    } finally {
      set(parentVoucherNotificationsLoadingAtom, false);
    }
  }
);

export const parentVoucherNotificationsUnreadCountAtom = atomWithDefault<number>(() => 0);

export const refetchParentVoucherNotificationsUnreadCountAtom = atom<
  number,
  undefined,
  Promise<void>
>(
  (get) => get(parentVoucherNotificationsUnreadCountAtom),
  async (_get, set) => {
    const count = await getParentVoucherNotificationsUnreadCount();
    set(parentVoucherNotificationsUnreadCountAtom, count);
  }
);
